import React, { useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { FiX } from "react-icons/fi";
import { FaPlus, FaTrash } from "react-icons/fa";

const AddBudgetModal = ({ show, handleClose }) => {

  // ✅ dynamic rows
  const [revenues, setRevenues] = useState([{ title: "", amount: "" }]);
  const [expenses, setExpenses] = useState([{ title: "", amount: "" }]);

  const addRevenue = () => {
    setRevenues([...revenues, { title: "", amount: "" }]);
  };

  const removeRevenue = (index) => {
    const updated = [...revenues];
    updated.splice(index, 1);
    setRevenues(updated);
  };

  const addExpense = () => {
    setExpenses([...expenses, { title: "", amount: "" }]);
  };

  const removeExpense = (index) => {
    const updated = [...expenses];
    updated.splice(index, 1);
    setExpenses(updated);
  };

  return (
    <Modal show={show} onHide={handleClose} centered className="custom-modal-width">
      <div className="custom-modal">

        {/* HEADER */}
        <div className="modal-header-custom">
          <h5>Add Budget</h5>
          <button className="close-btn" onClick={handleClose}>
            <FiX />
          </button>
        </div>

        {/* BODY */}
        <div className="modal-body-custom">
          <Form>

            <Form.Group className="mb-3">
              <Form.Label>Budget Title</Form.Label>
              <Form.Control />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Choose Budget respect type</Form.Label>
              <div className="radio-group">
                <Form.Check type="radio" label="Project" />
                <Form.Check type="radio" label="Category" />
              </div>
            </Form.Group>

            <Row>
              <Col>
                <Form.Label>Start Date</Form.Label>
                <Form.Control placeholder="dd/mm/yyyy" />
              </Col>
              <Col>
                <Form.Label>End Date</Form.Label>
                <Form.Control placeholder="dd/mm/yyyy" />
              </Col>
            </Row>

            {/* REVENUE */}
            <h6 className="section-title">Expected Revenues</h6>

            {revenues.map((item, index) => (
              <Row className="align-items-center mb-2" key={index}>
                <Col>
                  <Form.Control placeholder="Revenue Title" />
                </Col>

                <Col className="d-flex align-items-center">
                  <Form.Control placeholder="Revenue Amount" />

                  {/* ICONS */}
                  <div className="icon-group">
                    {index === 0 && (
                      <button type="button" className="icon-btn add" onClick={addRevenue}>
                        <FaPlus />
                      </button>
                    )}
                    {index > 0 && (
                      <button type="button" className="icon-btn delete" onClick={() => removeRevenue(index)}>
                        <FaTrash />
                      </button>
                    )}
                  </div>
                </Col>
              </Row>
            ))}

            <Form.Group className="mt-3">
              <Form.Label>Overall Revenue (A)</Form.Label>
              <Form.Control />
            </Form.Group>

            {/* EXPENSE */}
            <h6 className="section-title">Expected Expenses</h6>

            {expenses.map((item, index) => (
              <Row className="align-items-center mb-2" key={index}>
                <Col>
                  <Form.Control placeholder="Expenses Title" />
                </Col>

                <Col className="d-flex align-items-center">
                  <Form.Control placeholder="Expenses Amount" />

                  <div className="icon-group">
                    {index === 0 && (
                      <button type="button" className="icon-btn add" onClick={addExpense}>
                        <FaPlus />
                      </button>
                    )}
                    {index > 0 && (
                      <button type="button" className="icon-btn delete" onClick={() => removeExpense(index)}>
                        <FaTrash />
                      </button>
                    )}
                  </div>
                </Col>
              </Row>
            ))}

            <Form.Group className="mt-3">
              <Form.Label>Overall Expense (B)</Form.Label>
              <Form.Control />
            </Form.Group>

            {/* FINAL */}
            <Row className="mt-3">
              <Col>
                <Form.Label>Expected Profit (C=A-B)</Form.Label>
                <Form.Control />
              </Col>
              <Col>
                <Form.Label>Tax (D)</Form.Label>
                <Form.Control />
              </Col>
            </Row>

            <Form.Group className="mt-3">
              <Form.Label>Budget Amount (E=C-D)</Form.Label>
              <Form.Control />
            </Form.Group>

          </Form>
        </div>

        {/* FOOTER */}
        <div className="modal-footer-custom">
          <Button variant="light" onClick={handleClose}>
            Cancel
          </Button>
          <Button className="add-btn">
            Add Budget
          </Button>
        </div>

      </div>

      {/* CSS */}
      <style>{`
        /* 🔥 WIDTH FIX */
        .custom-modal-width .modal-dialog {
          max-width: 650px;
        }

        .custom-modal {
          border-radius: 10px;
        }

        .modal-header-custom {
          display: flex;
          justify-content: space-between;
          padding: 15px;
          border-bottom: 1px solid #eee;
        }

        .close-btn {
          border: none;
          background: transparent;
          font-size: 18px;
        }

        .modal-body-custom {
          padding: 15px;
        }

        .modal-footer-custom {
          padding: 15px;
          display: flex;
          justify-content: flex-end;
          gap: 10px;
          border-top: 1px solid #eee;
        }

        .section-title {
          margin-top: 15px;
          font-weight: 600;
        }

        .radio-group {
          display: flex;
          gap: 20px;
        }

        .add-btn {
          background: #ff7a2f;
          border: none;
          color: #fff;
        }

        /* 🔥 ICONS */
        .icon-group {
          display: flex;
          gap: 8px;
          margin-left: 8px;
        }

        .icon-btn {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
        }

        .icon-btn.add {
          background: #ff7a2f;
        }

        .icon-btn.delete {
          background: #ef4444;
        }

        /* MOBILE */
        @media (max-width: 768px) {
          .custom-modal-width .modal-dialog {
            max-width: 95%;
          }

          .icon-group {
            flex-direction: column;
          }
        }
      `}</style>
    </Modal>
  );
};

export default AddBudgetModal;